import React from "react";
import FooterContent from "./footer/FooterContent";
import { useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  return (
    <footer className="chatfooter mt-auto">
      <div className="container-fluid">
					<div className="row justify-content-center">
						<div className="col-md-12">
            <div className="d-flex flex-row justify-content-between">
								<div className="text-black d-flex flex-row gap-2" style={{
									// marginLeft: '12%',
									// marginTop: '1%'

								}}>
									Some information about the platform:
									<ul style={{
										listStyleType: 'none',
										paddingLeft: '0',
										marginLeft: '0',
										display: 'flex',
										flexDirection: 'row',
										gap: '10'
									}}>
										<li style={{borderRight: '1px solid black', paddingRight: '10px', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => navigate("/terms-and-conditions")}> Terms & conditions </li>
										<li style={{ paddingRight: '10px', textDecoration: 'underline', paddingLeft: '10px', cursor: 'pointer'}} onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
										{/* <li style={{cursor: 'pointer', paddingLeft: '10px', textDecoration: 'underline'}} onClick={() => navigate("/disclaimer")}>Disclaimer</li> */}
									</ul>
								</div>
								{/* <div className="row"> */}
									<div className="d-flex flex-row gap-2" style={{
										// marginRight: '10%',
										// paddingRight: '3%',
										// marginTop: '1%'
									}}>
										<div className="text-white px-3">
											Powered By: 
										</div>
										<div className="card d-flex align-items-center" style={{
												// width: '6%',
											}}>
												<img src="/newLogo.avif" alt="1CISO logo" style={{
													objectFit: 'contain',
													width: '55px',
													height: '25.32px'
													}}/>
										</div>
									</div>
								{/* </div> */}
							</div>
            </div>
          </div>
      </div>
      {/* <FooterContent className="chatfooter" /> */}
    </footer>
  );
};

export default Footer;